// extracted by mini-css-extract-plugin
module.exports = {"image":"Picture_image__3LsT8"};